<ng-template #content let-offcanvas>
  <div
    class="tw-relative tw-h-full tw-overflow-auto tw-rounded-t-lg tw-bg-search-form sm:tw-bg-none"
    ngbAutoFocus
  >
    <div class="tw-px-2.5 tw-py-[0.3125rem]">
      <button
        class="tw-size-7 tw-rounded-lg tw-text-xl tw-text-base-50 hover:tw-bg-secondary-600 sm:tw-text-base-600 sm:hover:tw-bg-base-100"
        type="button"
        (click)="offcanvas.dismiss('Dismiss')"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="tw-h-[calc(100%_-_2.375rem)] tw-overflow-auto tw-px-2.5">
      <app-search [showInDrawer]="true"></app-search>
    </div>
  </div>
</ng-template>
